import * as React from 'react';
import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox';
import { blue, neutral } from '../theme/colors';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  icon: {
    borderRadius: 3,
    width: 16,
    height: 16,
    border: `1px solid ${neutral[300]}`,
    backgroundColor: neutral[100],
    '$root.Mui-focusVisible &': {
      border: `1px solid ${blue[300]}`
    },
    'input:hover ~ &': {
      backgroundColor: blue[100]
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      border: `1px solid ${neutral[500]}`,
      background: neutral[500]
    }
  },
  checkedIcon: {
    border: `1px solid ${blue[600]}`,
    backgroundColor: blue[600],
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""'
    },
    'input:hover ~ &': {
      backgroundColor: blue[700],
      border: `1px solid ${blue[700]}`
    }
  }
});

/** Styled MUI Checkbox */
function StyledCheckbox(props: CheckboxProps) {
  const classes = useStyles();

  return (
    <Checkbox
      className={classes.root}
      disableRipple
      color="default"
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      inputProps={{ 'aria-label': 'decorative checkbox' }}
      {...props}
    />
  );
}

export default StyledCheckbox;
